import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Marker } from '@react-google-maps/api';

export const icons = {
  default: '/static/assets/map/pin.png',
  focused: '/static/assets/map/focusedPin.png',
  soldOut: '/static/assets/map/soldOutPin.png'
};

export default function PropertyMarker(props) {
  const {
    model,
    focused,
    onFocus,
    onClick,
    handlePropertySelectFromMarker,
    selectedPropertyId,
    clusterer,
    onPopUpOpen
  } = props;
  const [isMarkerClicked, setMarkerClicked] = useState(focused);

  const handleClick = () => {
    onFocus({ model });
    onPopUpOpen();
    onClick?.(model); // Notify parent
    handlePropertySelectFromMarker();
    setMarkerClicked(true);
  };

  const handleUrl = () => {
    if (model.availability === 'sold-out') {
      return icons.soldOut;
    }
    return focused ? icons.focused : icons.default;
  };

  return (
    <Marker
      clusterer={clusterer}
      position={{ lat: model.lat, lng: model.lng }}
      onClick={handleClick}
      focused={selectedPropertyId === model.id || isMarkerClicked}
      icon={{ url: handleUrl() }}
    />
  );
}

PropertyMarker.propTypes = {
  model: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    availability: PropTypes.string
  }).isRequired,
  focused: PropTypes.bool,
  onFocus: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  handlePropertySelectFromMarker: PropTypes.func.isRequired,
  selectedPropertyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  clusterer: PropTypes.shape({}),
  onPopUpOpen: PropTypes.func.isRequired
};

PropertyMarker.defaultProps = {
  focused: false,
  onClick: null,
  selectedPropertyId: null,
  clusterer: null
};
